import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'VAInputNumber',
  props: {
  value: {
    type: Number,
    required: true
  },
  disabled: {
    type: Boolean
  },
  placeholder: {
    type: String
  }
},
  emits: ["update:value"],
  setup(__props, { emit: __emit }) {


const emit = __emit



const change = (value: number) =>{
  emit("update:value", value)
}


return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!

  return (_openBlock(), _createBlock(_component_a_input_number, {
    value: __props.value,
    disabled: __props.disabled,
    placeholder: __props.placeholder,
    onChange: change
  }, null, 8, ["value", "disabled", "placeholder"]))
}
}

})